import React from 'react';

import { useTranslation } from 'react-i18next';
import { Point, Area } from 'react-easy-crop/types';
import Cropper from 'react-easy-crop';
import { Button, Form } from 'react-bootstrap';
import { faRedo } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProfile } from '@pegasus/workforce-icons';

import './styles.scss';

interface IImagePositionProps {
    image: string | undefined;
    setCroppedAreaPixels: React.Dispatch<React.SetStateAction<Area | null>>;
    setRotation: React.Dispatch<React.SetStateAction<number>>;
    rotation: number;
}

export const ImagePosition = ({image, setCroppedAreaPixels, setRotation, rotation}: IImagePositionProps) => {
    const [crop, setCrop] = React.useState<Point>({x: 0, y: 0});
    const [zoom, setZoom] = React.useState<number>(1);

    const {t} = useTranslation();

    const onCropComplete = React.useCallback((croppedArea: Area, croppedAreaPixels: Area) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, [setCroppedAreaPixels]);

    const handleSetRotation = ((rotation: number) => {
        setRotation((prevState: number) => {
            return prevState + rotation;
        });
    });

    return (
        <div className="ImagePosition">
            <div className="ImagePosition__cropContainer">
                <Cropper
                    image={image}
                    crop={crop}
                    zoom={zoom}
                    style={{cropAreaStyle: {color: '#f6f6f6', border: '1px solid #dddddd'}}}
                    cropSize={{width: 286, height: 317}}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                    showGrid={false}
                    rotation={rotation}
                    onRotationChange={setRotation}
                />
                <div className="ImagePosition__cropMask"/>
            </div>

            <div className="ImagePosition__imageControls">
                <div className="ImagePosition__sliderBox">
                    <IconProfile className="ImagePosition__profileIcon"/>
                    <Form.Control
                        className="ImagePosition__range"
                        type="range"
                        onChange={(e) => {
                            setZoom(Number(e.target.value));
                        }}
                        value={zoom}
                        min={1}
                        max={3}
                        step={0.1}
                    />
                    <IconProfile className="ImagePosition__profileIcon-lg"/>
                </div>
                <div className="ImagePosition__rotateButtons mb-4">
                    <Button
                        variant="secondary"
                        className="ImagePosition__rotateButton"
                        onClick={() => handleSetRotation(-90)}
                    >
                        {t('actions.rotate', 'Rotate')}
                        <FontAwesomeIcon className="fa-flip-horizontal ml-2" icon={faRedo} size="lg"/>
                    </Button>
                    <Button
                        variant="secondary"
                        className="ImagePosition__rotateButton"
                        onClick={() => handleSetRotation(90)}
                    >
                        <FontAwesomeIcon className="mr-2" icon={faRedo} size="lg"/>
                        {t('actions.rotate', 'Rotate')}
                    </Button>
                </div>
            </div>
        </div>
    );
};
